import React, { ReactChild, HTMLAttributes } from 'react'

export interface ITableRowProps extends HTMLAttributes<HTMLTableRowElement>{
  children: ReactChild | ReactChild[];
}

export default function TableRow({children, ...props}: ITableRowProps) {
  return (
    <tr {...props}>
      {children}
    </tr>
  )
}
